import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerGalleryClick = props => {
  const datalayerGalleryClickHandler = event => {
    if (
      containsValidTargetClass(
        ["ter-image-gallery__image"],
        event?.target?.classList
      )
    ) {
      window.dataLayer.push({
        event: "gallery_click",
        click_media_src: event?.target?.baseURI,
        gallery_item_number: event?.target?.parentElement?.dataset?.thumbIndex,
        total_gallery_items: event?.target?.closest(
          ".ter-image-gallery__thumbnails"
        ).children?.length,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll(".ter-image-gallery__image").length > 0
  }
  useClickListener(datalayerGalleryClickHandler, query)
}

export default DatalayerGalleryClick
